import React from 'react';
import { profile } from '../../../data/profile';
import { programs } from '../../../data/programs';
import Popular from './popular';
import { pubs } from '../../../data/pubs';
import _ from 'lodash';
import bg from '../../../assets/images/profle/1.jpg';
import { useNavigate } from 'react-router-dom';

const Welcome = () => {
  const navigate = useNavigate();
  const pub = _.last(pubs);
  const sortedPubs = _.orderBy(pub.item, 'id', 'desc');
  const research = _.slice(sortedPubs, 0, 3);

  return (
    <>
      {/* Hero Section */}
      <div className="relative w-full h-[500px]">
        <img 
  src={bg} 
  alt="cover" 
  className="w-full h-full object-cover object-bottom" 
/>
<div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col justify-end items-center text-center px-2 pb-10">
  <h1 className="text-5xl sm:text-3xl xs:text-2xl text-white font-bold font-montserrat">
    Welcome to Benadir University
  </h1>
          <p className="text-lg sm:text-base xs:text-sm text-gray-200 mt-2 italic font-light">
            Cultivating Human Talents
          </p>
          <button
            onClick={() => navigate('/')}
            className="mt-5 bg-[#0863aa] text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            Explore
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col md:flex-row xl:flex-row w-[90%] mx-auto mt-10 gap-10">
        {/* Left Column: Profile Sections */}
        <div className="flex flex-col md:w-2/3 xl:w-2/3 space-y-10">
          {profile.map((p) => (
            <div
              key={p.id}
              className="bg-white shadow-lg rounded-2xl p-6 transition-transform transform hover:scale-105 hover:shadow-2xl"
            >
              {/* Heading without icon */}
              <div className="mb-4">
                <div className="bg-[#0863aa] px-4 py-1 rounded-lg shadow">
                  <p className="text-white font-semibold text-lg">{p.title}</p>
                </div>
              </div>

              {/* Description */}
              <p className="text-gray-700 text-justify mb-4">{p.desc}</p>

              {/* Images */}
              {p.img.length > 0 && (
                <div className="grid grid-cols-3 sm:grid-cols-1 gap-4 mt-10">
                  {p.img.map((m) => (
                    <div
                      key={m.id}
                      className="overflow-hidden rounded-xl shadow-md"
                    >
                      <img
                        src={m.img}
                        alt="profile"
                        className="w-full h-48 object-cover transition-transform transform hover:scale-105"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Right Column: Programs & Research */}
        <div className="md:w-1/3 xl:w-1/3 flex flex-col space-y-10 px-5 md:border-l-2 xl:border-l-2 sm:mt-10 xs:mt-10">
          {/* Most Popular Programs */}
          <div className="bg-white shadow-lg rounded-2xl p-6">
            <h2 className="text-xl font-bold mb-4">Most Popular Programs</h2>
            <hr className="mb-4" />
            {programs[0].lists.map((p) => (
              <div key={p.id} className="mb-3">
                <p className="text-primary">{p.program}</p>
              </div>
            ))}
          </div>

          {/* Most Popular Research Finds */}
          <div className="bg-white shadow-lg rounded-2xl p-6">
            <h2 className="text-xl font-bold mb-4">
              Most Popular Research Finds
            </h2>
            <hr className="mb-4" />
            {research.map((r) => (
              <div key={r.id} className="mb-3">
                <a
                  href={r.doi}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  {r.title}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Welcome;
